/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaseFolder
 */
export interface CaseFolder {
    /**
     * 
     * @type {string}
     * @memberof CaseFolder
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFolder
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFolder
     */
    caseId: string;
    /**
     * 
     * @type {string}
     * @memberof CaseFolder
     */
    folderId?: string | null;
}

export function CaseFolderFromJSON(json: any): CaseFolder {
    return CaseFolderFromJSONTyped(json, false);
}

export function CaseFolderFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaseFolder {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'caseId': json['caseId'],
        'folderId': !exists(json, 'folderId') ? undefined : json['folderId'],
    };
}

export function CaseFolderToJSON(value?: CaseFolder | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'caseId': value.caseId,
        'folderId': value.folderId,
    };
}


